import React from 'react';
import PropTypes from 'prop-types';

class InputPopup extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return(
      <div className="input-error-popup">
        { this.props.message }
      </div>
    );
  }
}

InputPopup.propTypes = {
  message:  PropTypes.string,
}

export default InputPopup;